export const stateName = 'screen' as const
